module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc25b-f836481ff617d14e61ff29b9d06175d5.jpg";